import Notification from './Notification';
export default Notification;


//////////////////
// WEBPACK FOOTER
// ../~/_rc-notification@3.3.1@rc-notification/es/index.js
// module id = 615
// module chunks = 0